import React from 'react';
import { Space } from 'common/layout/helpers';

export default function FormVerticalSpace({ size = 15 }: { size?: number }) {
  return <Space direction="vertical" size={size} />;
}
